import { baseApiUrl, fetcher, handleError, ServerErrorResponse } from 'data_sources/constants';
import {
  OrganizationPerformanceReportingConfig,
  UpdateOrganizationPerformanceReportingConfigObject,
} from '../../../_types/performanceReporting';

export const updateOrganizationPerformanceReportingConfig = async (
  orgId: string,
  config: UpdateOrganizationPerformanceReportingConfigObject,
  callback?: (data: OrganizationPerformanceReportingConfig) => void,
  onError?: (errors: ServerErrorResponse) => void
): Promise<OrganizationPerformanceReportingConfig> => {
  if (!orgId) throw new Error('No organization ID provided.');

  const url = `${baseApiUrl()}/admin-solution/v1/organizations/${orgId}/solutions/performance-reporting/config`;

  try {
    const response = await fetcher({
      method: 'PUT',
      url,
      body: config,
    });

    if (callback) callback(response);
    return response;
  } catch (err: any) {
    if (onError) handleError(err, { onError });
    throw err;
  }
};
